import { useState, useEffect } from "react";
import { supabase } from "../supabaseClient";

export function useSession() {
  const [session, setSession] = useState(null);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const getSession = async () => {
      const { data } = await supabase.auth.getSession();
      setSession(data.session);

      if (data.session) {
        const { data: userData } = await supabase
          .from("users")
          .select("role")
          .eq("id", data.session.user.id)
          .single();
        setUserRole(userData?.role);
      }
    };
    getSession();

    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      if (!session) setUserRole(null);
    });

    return () => listener.subscription.unsubscribe();
  }, []);

  return { session, userRole };
}
